import { default as React, FC } from 'react';
import styled from 'styled-components';
import { Content } from '../../components/content';
import { CustomerTiles } from '../../components/CustomerTiles';
import { Header } from '../../components/header/header';
import { Page } from '../../components/page';
import { PageHeading } from '../../components/page-heading/page-heading';
import { ResultsCount } from '../../components/results-count';
import { IOrder, IVMIOrder, Status } from '../../graphql/types';
import { White } from '../../styles/colours';
import { SoldToSearchControls } from '../sold-to/search-controls';
import { OrderDetailsBody } from './body';
import { OrderDetailsBreadcrumbs } from './breadcrumbs';
import { OrderSummaryCard } from './order-summary-card';
import { PotentialOrderTable } from './potential-order-table/potential-table';
import { GetOrderByIdQuery } from './queries/order-by-id';
import { GetPotentialOrderByIdQuery } from './queries/potential-order-by-id';
import { POTENTIAL_ORDER_DETAILS_PAGE_ROUTE } from './route';

const StyledTopSection = styled.div`
  background-color: ${White};
  padding: 0rem 0rem 3rem 7.5rem;
`;

const StyledBottomSection = styled.div`
  padding: 0rem 7.5rem 3rem 7.5rem;
`;

const StyledSearch = styled.div`
  padding: 1rem 0rem 0rem 0rem;
`;

export const PotentialOrderDetailsPage: FC<{
  orderId: string;
  shipToId: string;
}> = ({ shipToId, orderId }) => {
  return (
    <Page
      data-type="page"
      data-page={POTENTIAL_ORDER_DETAILS_PAGE_ROUTE}
      data-ship-to-id={shipToId}
      data-order-id={orderId}
    >
      <Header />
      <Content>
        <GetPotentialOrderByIdQuery
          id={orderId}
          shipToId={shipToId}
          render={(order: IVMIOrder) => {
            return (
              <>
                <StyledTopSection>
                  <OrderDetailsBreadcrumbs
                    shipTo={order.shipTo}
                    soldTo={order.soldTo}
                  />
                  <PageHeading>Order details</PageHeading>
                  <CustomerTiles
                    soldTo={order.soldTo}
                    shipTo={order.shipTo}
                    showRemoveLink={false}
                    isVmiSite={order.vmiIndicator}
                  />
                </StyledTopSection>
                <StyledBottomSection>
                  <StyledSearch>
                    <ResultsCount
                      label="Ship-To orders"
                      count={order.items.length || 0}
                    />
                  </StyledSearch>
                  <PotentialOrderTable order={order} />
                </StyledBottomSection>
              </>
            );
          }}
        />
      </Content>
    </Page>
  );
};
